import { Component, OnDestroy, OnInit,  EventEmitter, Input, Output, ViewContainerRef, ViewChild, TemplateRef} from '@angular/core';
import { ReactiveFormsModule, FormGroup, FormBuilder, FormControl } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import {DemoService} from '../../../demo.service';
import {Routes, RouterModule, Router} from '@angular/router';
import { ActivatedRoute } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import {Location} from '@angular/common';
// Notifications
import { HotToastService } from '@ngneat/hot-toast';
import { DatePipe } from '@angular/common';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { Observable, map, Subscription } from 'rxjs'; // this created errors ats use below

import { FileUploadsModalComponent } from './../../../manager/file-uploads-modal/file-uploads-modal.component';
import {UploadDocxTemplateModalComponent} from './../../communication-manager/upload-docx-template-modal/upload-docx-template-modal.component';
import {UploadEmailTemplateModalComponent} from './../../communication-manager/upload-email-template-modal/upload-email-template-modal.component';

import {UploadDotTemplateModalComponent} from './../../communication-manager/upload-dot-template-modal/upload-dot-template-modal.component';


import { MysqlService } from './../../../services/mysql.service';
import { Brand } from '../../../shared/models/brand.model';
import {SubjectTemplateDocs} from '../../../shared/models/subjectTemplateDocsModel.model';
import {SystemFile} from './../../../shared/models/file.model';

import { FormsModule, Validators } from '@angular/forms';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';

import { ToolbarService, LinkService, ImageService, HtmlEditorService } from '@syncfusion/ej2-angular-richtexteditor';
import {
  RichTextEditorComponent,
  NodeSelection
} from '@syncfusion/ej2-angular-richtexteditor';
import { GlobalFunctionsService } from './../../../services/global-functions.service';

@Component({
  selector: 'app-system-file-edit',
  templateUrl: './system-file-edit.component.html',
  styleUrls: ['./system-file-edit.component.css'],
  providers: [ToolbarService, LinkService, ImageService, HtmlEditorService]
})
export class SystemFileEditComponent implements OnInit {
  nav: any;
  model: SystemFile;
  subject_template_doc: Object;
  // doc_id; // 


// setup as observable?
@Input() item_id?: Observable<any[]>; // impliments on changes.
@Input() item_data?: Observable<any[]>; // if data.model is sent : Observable<any[]>;
@Input() use_item_data? = 'no'; // if data.model is sent use this instead of item_id
@Input() item_user_level_id? = '5'; // default to agent just in case
@Input() item_brand_type_id? = '';
@Input() show_buttons? = 'no'; // yes | no
@Input() widget_title? = '';
@Input() widget_size? = 'side'; // side | abstract | full

// doc_id: number;
@Input() doc_id?;
@Input() file_id: number;



  public baseUploadURL: any;
  @ViewChild('brandForm') form: any; // the name of the form to access.
  bsModalRef: BsModalRef;
  // MODAL
  modalRef: BsModalRef;
  stripped: any;
  filenameselected: any;
  brand_types: any;
  baseUploadURLEmailTemplates: string;
  subject_com_types: Object;
  sent_subject_com_type_id: any;

  job_types: any;
  job_subject_types: any;
  job_plaintiff_types: any;
  job_type_locations: any;
  count2: any;
  job_type_courts: any;
  sent_job_type_location_id: any;
  job_type_document_types: any;
  sent_job_type_court_id: any;
  job_type_affidavit_types: any;
  sent_job_type_document_type_id: any;
  doc_check: Object;

  get_name: Object;
  baseUploadURLOriginalWordTemplates: string;

  public myValue = 0;
  system_file_data: any;
  assignedAgentsList: Object;
  allRecipients: any;


  constructor(
    private _mysqlService: MysqlService,
    private route: ActivatedRoute,
      private router: Router,
      private http: HttpClient,
      private _demoService: DemoService,
      public toastr: HotToastService,
      vcr: ViewContainerRef,
      private modalService: BsModalService,
      private _location: Location,
      public datepipe: DatePipe,
      public gfunc: GlobalFunctionsService
  ) {
    this.nav = document.querySelector('nav.navbar');


    // if not yet set check the route. 
    if(!this.file_id){
    this.file_id = +this.route.snapshot.paramMap.get('file_id');
    }

  }

  ngOnInit() {
    // this.baseUploadURL = this.gfunc.baseUploadURL_BrandAssets + '/'  + this.doc_id; // no trailing slash
    this.baseUploadURL = this.gfunc.baseUploadURL; // all templates reside in the same directory.
    this.baseUploadURLOriginalWordTemplates = this.gfunc.baseUploadURLOriginalWordTemplates;
    this.baseUploadURLEmailTemplates = this.gfunc.baseUploadURLEmailTemplates; // all templates reside in the same directory.
   // this.model = new SubjectTemplateDocs(); only for create components
    // this.getSubjectTemplateDoc(this.doc_id);
    this.getBrandTypes();
    this.getSubjectComTypes();
    this.getJobTypes();
 
 
    this.model = new SystemFile;
    this.getSystemFile(this.file_id);
 
  }



  getSystemFile(file_id){
    this._demoService.getSystemFile(file_id).subscribe(
       data => { 
         this.system_file_data = data;
         let res = data[0];
         this.getSubjectAgentBrandsAssigned(res.file_subject_id);
      
      },
       err => console.error(err),
       // () => console.log('done loading Trace Types')
     );

}



  getSubjectTemplateDoc(doc_id) {
    this._demoService.getSubjectTemplateDoc(doc_id).subscribe(
      data => { this.subject_template_doc = data;
        const res = data[0];
        // load the drop downs
        this.getJobTypeLocations(res.job_type_id);
        this.getJobTypeCourts(res.job_type_location_id);
        this.getJobTypeDocumentTypes(res.job_type_court_id);
        this.getJobTypeAffidavitTypes(res.job_type_document_type_id);
        // this.getJobTypes();

      },
      err => console.error(err),
      () => console.log('')
    );
  }

// need to change this below
updateSystemFile(model) {
  // model.job_id = this.job_id;

  // testing to add here is more simple.
  model.assigned_to_agents = JSON.stringify(this.allRecipients);


   this._demoService.updateFile(model).subscribe(

    data => { // this.trace_candidate_update = data;
      // refresh the list
     // this.getTraceCandidate(this.model.trace_candidate_id);  // created bugs...
    this.toastr.success('System File Updated');
  //  this.createJobSubjectsMultiple(model);
    // Subject to reload the manager component parent.
   // TraceCandidateManagerComponent.returned.next(false);
  // this.router.navigate(['/admin/jobs/create-job-3/' + model.job_id + '']);
  // this.router.navigate(['/admin/jobs/view/' + model.job_id + '']);

              return true;
    },
    // error => {
    //  // console.error('Error saving Event!');
    //   this.toastr.error('Error saving Document!');
    //   return Observable.throw(error);
    // },
    err => console.error(err),
    () => console.log('done updates')
);
  }

  // need to change this below
editDoc(model) {
  // model.job_id = this.job_id;
   this._demoService.updateSubjectTemplateDoc(model).subscribe(

    data => { // this.trace_candidate_update = data;
      // refresh the list
     // this.getTraceCandidate(this.model.trace_candidate_id);  // created bugs...
    this.toastr.success('Document Updated');
  //  this.createJobSubjectsMultiple(model);
    // Subject to reload the manager component parent.
   // TraceCandidateManagerComponent.returned.next(false);
  // this.router.navigate(['/admin/jobs/create-job-3/' + model.job_id + '']);
  // this.router.navigate(['/admin/jobs/view/' + model.job_id + '']);

              return true;
    },
    // error => {
    //  // console.error('Error saving Event!');
    //   this.toastr.error('Error saving Document!');
    //   return Observable.throw(error);
    // },
    err => console.error(err),
    () => console.log('done updates')
);
  }



 getBrandTypes() {
  this._demoService.getBrandBrandTypes().subscribe(
     data => { this.brand_types = data; },
     err => console.error(err),
     // () => console.log('done loading candidate for update')
   );
 }


     // to router navigate back
     public goBack() {
      this._location.back();
    }

    docView(doc_id) {
      this.router.navigate(['/admin/communication/com_type_template_doc_view/' + doc_id + '']);
    }

    docEdit(doc_id) {
      this.router.navigate(['/admin/communication/com_type_template_doc_edit/' + doc_id + '']);
    }





   // MODAL view a component
   openModalWithComponent() {
    const initialState = {
      title: 'Upload Template Document',
      item_id: 1010,
      doc_id: this.doc_id,
      size: 'lg',
      backdrop: true,
      IgnoreBackdropClick: false,
    };
    this.bsModalRef = this.modalService.show(UploadDocxTemplateModalComponent, {initialState});
    // sets the var to in the component model
    this.bsModalRef.content.doc_id = this.doc_id;
    this.bsModalRef.content.item_id = this.doc_id;
    this.bsModalRef.content.title = 'Communication Template Document Manager';
    this.bsModalRef.content.closeBtnName = 'Close';
   // this.bsModalRef.content.brand_model = this.subject_template_doc;
    // subscribed to the emitter and get the value.
          //     this.bsModalRef.content.action.take(1).subscribe((value) => {
          //   // console.log(value); // here you will get the value of the file
          //   // Remove the "uploads/" part from the filename.
          //   this.filenameselected = value;
          //  // this.stripped = this.filenameselected.replace('uploads/', '');
          //   // this.model.main_image = this.stripped; // works for simple add not update.
          //   // console.log(this.stripped);
          //   // console.log(this.model);
          //   // this.form.logo = this.stripped;
          //   this.form.doc_template_file = this.filenameselected;
          //   // this.form.reset();
          //   // must set  @ViewChild('brandForm') form: any; declaration in top of component first!
          //   this.form.controls['doc_template_file'].patchValue(this.form.doc_template_file);

          //   });
          this.bsModalRef.content.action.subscribe(this.addFileNameFromModal.bind(this));
   }

		// :: Parent / Child modal test
		public addFileNameFromModal(filename) {
		  alert('Clicked');
		  this.form.controls['doc_template_file'].patchValue(filename); // works by setting the new frorm value from parent modal.
      // has to be correct form name
		// this.modalRef.hide();
		// console.log('Added External Recipeint.');
		// this.toastr.info('External Recipient Added');
		};


      // MODAL view a component
      openModalDotComponent() {
        const initialState = {
          title: 'Upload Template Document',
          item_id: 1010,
          doc_id: this.doc_id,
          size: 'lg',
          backdrop: true,
          IgnoreBackdropClick: false,
        };
        this.bsModalRef = this.modalService.show(UploadDotTemplateModalComponent, {initialState});
        // sets the var to in the component model
        this.bsModalRef.content.doc_id = this.doc_id;
        this.bsModalRef.content.item_id = this.doc_id;
        this.bsModalRef.content.title = 'Original Word Files';
        this.bsModalRef.content.closeBtnName = 'Close';
       // this.bsModalRef.content.brand_model = this.subject_template_doc;
        // subscribed to the emitter and get the value.
          //     this.bsModalRef.content.action.take(1).subscribe((value) => {
          //   // console.log(value); // here you will get the value of the file
          //   // Remove the "uploads/" part from the filename.
          //   this.filenameselected = value;
          //  // this.stripped = this.filenameselected.replace('uploads/', '');
          //   // this.model.main_image = this.stripped; // works for simple add not update.
          //   // console.log(this.stripped);
          //   // console.log(this.model);
          //   // this.form.logo = this.stripped;
          //  // this.form.doc_template_file = this.filenameselected;
          //   this.form.original_doc_file = this.filenameselected;
          //   // this.form.reset();
          //   // must set  @ViewChild('brandForm') form: any; declaration in top of component first!
          //   this.form.controls['original_doc_file'].patchValue(this.form.original_doc_file);

          //   });

          this.bsModalRef.content.action.subscribe(this.addFileNameFromModal_ODF.bind(this)); /// Angular 14 working.....
        }

		// :: Parent / Child modal test
		public addFileNameFromModal_ODF(filename) {
		  alert('Clicked');
		  this.form.controls['original_doc_file'].patchValue(filename); // works by setting the new frorm value from parent modal.
      // has to be correct form name
		// this.modalRef.hide();
		// console.log('Added External Recipeint.');
		// this.toastr.info('External Recipient Added');
		};

   // MODAL view a component
   openModalEmailTemplates() {
    const initialState = {
      size: 'lg',
      backdrop: true,
      IgnoreBackdropClick: false,
    };
    this.bsModalRef = this.modalService.show(UploadEmailTemplateModalComponent, {initialState});
    // sets the var to in the component model
    this.bsModalRef.content.doc_id = this.doc_id;
    this.bsModalRef.content.item_id = this.doc_id;
    this.bsModalRef.content.title = 'Email Template Manager';
    this.bsModalRef.content.closeBtnName = 'Close';
   // this.bsModalRef.content.brand_model = this.subject_template_doc;
    // subscribed to the emitter and get the value.
        //     this.bsModalRef.content.action.take(1).subscribe((value) => {
        //   // console.log(value); // here you will get the value of the file
        //   // Remove the "uploads/" part from the filename.
        //   this.filenameselected = value;
        //  // this.stripped = this.filenameselected.replace('uploads/', '');
        //   // this.model.main_image = this.stripped; // works for simple add not update.
        //   // console.log(this.stripped);
        //   // console.log(this.model);
        //   // this.form.logo = this.stripped;
        //   this.form.email_template = this.filenameselected;
        //   // this.form.reset();
        //   // must set  @ViewChild('brandForm') form: any; declaration in top of component first!
        //   this.form.controls['email_template'].patchValue(this.form.email_template);

        //   });
        this.bsModalRef.content.action.subscribe(this.addFileNameFromModal_ET.bind(this)); /// Angular 14 working.....

   }

		// :: Parent / Child modal test
		public addFileNameFromModal_ET(filename) {
		  alert('Clicked');
		  this.form.controls['email_template'].patchValue(filename); // works by setting the new frorm value from parent modal.
      // has to be correct form name
		// this.modalRef.hide();
		// console.log('Added External Recipeint.');
		// this.toastr.info('External Recipient Added');
		};




   private getSubjectComTypes() {
    this._demoService.getSubjectComTypes()
      .subscribe(
        res => this.subject_com_types = res,
        err => console.error(err.status)
      );
  }



sendSubjectComTypeID(subject_com_type_id) {
// do nothing
  }



   // BOF SHARMANS CALLS
   getJobTypes() {
    this._demoService.getJobTypes().subscribe(
       data => { this.job_types = data; },
       err => console.error(err),
       // () => console.log('done loading Trace Types')
     );
   }

   getJobSubjectTypes() {
    this._demoService.getJobSubjectTypes().subscribe(
       data => { this.job_subject_types = data; },
       err => console.error(err),
       // () => console.log('done loading Trace Types')
     );
   }

   getJobPlaintiffTypes() {
    this._demoService.getJobPlaintiffTypes().subscribe(
       data => { this.job_plaintiff_types = data; },
       err => console.error(err),
       // () => console.log('done loading Trace Types')
     );
   }


   getJobTypeLocations(job_type_id) {
    this._demoService.getJobTypeLocations(job_type_id).subscribe(
       data => { this.job_type_locations = data; },
       err => console.error(err),
       // () => console.log('done loading Trace Types')
     );
   }


   sendJobTypeLocationsID(job_type_id) {
    // this.initialCount = this.trace_candidates.trace_candidate_id;
    this.count2 = job_type_id;
    this.getJobTypeLocations(this.count2); // updates the selected job ID....



   console.log('sending Count:' + this.count2);
  }


  getJobTypeCourts(job_type_location_id) {
    this._demoService.getJobTypeCourts(job_type_location_id).subscribe(
       data => { this.job_type_courts = data; },
       err => console.error(err),
       // () => console.log('done loading Trace Types')
     );
   }


   sendJobTypeCourtsID(job_type_location_id) {
    // this.initialCount = this.trace_candidates.trace_candidate_id;
    this.sent_job_type_location_id = job_type_location_id;
    this.getJobTypeCourts(this.sent_job_type_location_id); // updates the selected job ID....



   console.log('sending Location:' + this.sent_job_type_location_id);
  }


  getJobTypeDocumentTypes(job_type_court_id) {
    this._demoService.getJobTypeDocumentTypes(job_type_court_id).subscribe(
       data => { this.job_type_document_types = data; },
       err => console.error(err),
       // () => console.log('done loading Trace Types')
     );
   }


   sendJobTypeDocumentTypesID(job_type_court_id) {
    // this.initialCount = this.trace_candidates.trace_candidate_id;
    this.sent_job_type_court_id = job_type_court_id;
    this.getJobTypeDocumentTypes(this.sent_job_type_court_id); // updates the selected job ID....


   console.log('sending Court Type:' + this.sent_job_type_court_id);
  }


  getJobTypeAffidavitTypes(job_type_document_type_id) {
    this._demoService.getJobTypeAffidavitTypes(job_type_document_type_id).subscribe(
       data => { this.job_type_affidavit_types = data; },
       err => console.error(err),
       // () => console.log('done loading Trace Types')
     );
   }


   sendJobTypeAffidavitTypesID(job_type_document_type_id) {
    // this.initialCount = this.trace_candidates.trace_candidate_id;
    this.sent_job_type_document_type_id = job_type_document_type_id;
    this.getJobTypeAffidavitTypes(this.sent_job_type_document_type_id); // updates the selected job ID....

   console.log('sending Doc Type:' + this.sent_job_type_document_type_id);
  }


 // get name for form.
 getJobTypeAllAffidavitType(job_type_affidavit_type_id) {
  this._demoService.getJobTypeAllAffidavitType(job_type_affidavit_type_id)
    .subscribe(
      res => this.get_name = res,
      err => console.error(err.status)
    );
}
getSubjectTemplateDocsCheck(model) {
  // need to do a lookup to get name of doc....
 // this.getJobTypeAllAffidavitType(model.job_type_affidavit_type_id);
  // set the name
  // this.model.doc_name = this.get_name[0].job_type_affidavit_type_name;
   this._demoService.getSubjectTemplateDocsCheck(model).subscribe(
      data => { this.doc_check = data;
     },
      err => console.error(err),
      // () => console.log('done loading Trace Types')
    );
  }


  docEditTemplateFile(doc_id) {
    this.router.navigate(['/admin/communication/template_doc_view/template/' + doc_id + '']);
  }



  viewSystemFile(file_id) {
    this.router.navigate(['/admin/system-file-manager/system-file/' + file_id + '']);
  }
  
  editSystemFile(file_id) {
    this.router.navigate(['/admin/system-file-manager/system-file-edit/' + file_id + '']);
  }
  
  editDocFile(file_id) {
    this.router.navigate(['/admin/system-file-manager/system-doc-edit/' + file_id + '']);
  }
  
  
  editDocxSystemFile(file_id) {
    this.router.navigate(['/admin/system-file-manager/system-doc-edit/docx-edit/' + file_id + '']);
  }
  
  
  viewDocxSystemFile(file_id) {
    this.router.navigate(['/admin/system-file-manager/system-doc-edit/docx-view/' + file_id + '']);
  }
  







// need to get all associated agents of the job and push thier information to array
getSubjectAgentBrandsAssigned(subject_id) {
  this.allRecipients = [];
  this._demoService.getSubjectAgentBrandsAssigned(subject_id).subscribe(
     data => { 
       this.assignedAgentsList = data;

       let newArr = data;
       let  count_of_items = Object.keys(newArr).length;
         // need to do a loop of subject_billing items (.length)
         for(let i=0;i < count_of_items; i++) {
         let res = newArr[i];
         this.allRecipients.push({
           recipient_name: res.name + '',
           recipient_email_address: res.email,
           recipient_brand_id: res.brand_id,
           recipient_subject_id: res.subject_id,
           recipient_brand_type_id: res.brand_type_id,
           recipient_user_id: null,
           recipient_user_level_id: null,
           recipient_type_name: 'Agent',
         });
         } // end for loop
       this.allRecipients = this.allRecipients; // ?? this may be causing errors.

       // do an array compaire and remove if not the same.
       
       // set records to send to subject_notes data table
       this.model.assigned_to_agents  = JSON.stringify(this.allRecipients);

    },
     err => console.error(err),
     // () => console.log('Loaded Assigned Agents Loaded.')
   );
 }


 RemoveElementFromAllRecipients(key: number) {
  // removes all matching names, so it can remove multiple accidently. if they have different roles. etc
  this.allRecipients.forEach((value, index) => {
    if (value.recipient_name === key) {
      this.allRecipients.splice(index, 1);
    }
  });

  // now reset the edit form value
         // set records to send to subject_notes data table
        //  JSON.parse();
  this.model.assigned_to_agents = JSON.stringify(this.allRecipients);


    // :: Specifcally removes the array item without there being
    // :: @https://stackoverflow.com/questions/5767325/how-can-i-remove-a-specific-item-from-an-array

};






}
